import React, { useMemo } from 'react';
import { VirtualSlotsPlaceholderContext, VirtualSlotsPlaceholderHighlightContext, VirtualSlotsPlaceholderHostId, } from './slotsPlaceholderContext';
import { extractSlotState } from './utils/extractSlotsState';
export function withSlotsPlaceholders(Component) {
    return (props) => {
        const { slots, compPreviewState, id, ...otherProps } = props;
        const slotStateData = useMemo(() => {
            if (!compPreviewState) {
                return {};
            }
            const { slotId, slotState } = extractSlotState(compPreviewState);
            return {
                [slotId]: slotState,
            };
        }, [compPreviewState]);
        return (React.createElement(VirtualSlotsPlaceholderHostId.Provider, { value: id },
            React.createElement(VirtualSlotsPlaceholderContext.Provider, { value: slots },
                React.createElement(VirtualSlotsPlaceholderHighlightContext.Provider, { value: slotStateData },
                    React.createElement(Component, { ...otherProps })))));
    };
}
//# sourceMappingURL=withSlotsPlaceholders.js.map